import React from 'react';
import { db } from '../../utils/firebase';
import firebase from 'firebase/app'
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TableComponent from '../../components/TableComponent';
import { filterArchivedQuestions } from '../../utils/miscFunctions';
import CreateQuestion from '../../components/Surveys/CreateQuestion';
import QuestionContext from '../../QuestionContext';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

const styles = {
    'search': {
        width: '50%',
        margin: 10
    },
    'select': {
        width: '22%',
        margin: 5,
        height: 60,
        fontSize: 16,
    },
    'button': {
        backgroundColor: '#0256c5',
        color: 'white',
        cursor: 'pointer',
        borderRadius: 8,
        fontSize: 16,
        padding: 10,
        margin: 10,
    }
}

const languages = [
    { value: 'en', label: 'English' },
    { value: 'es', label: 'Spanish' },
    { value: 'ch', label: 'Chinese' },
    { value: 'ru', label: 'Russian' },
    { value: 'fr', label: 'French' },
    { value: 'tl', label: 'Tagalog' },
    { value: 'vi', label: 'Vietnamese' },
    { value: 'ar', label: 'Arabic' },
    { value: 'so', label: 'Somali' },
    { value: 'ko', label: 'Korean' }
]

const types = [
    { value: 'opinion_scale', label: 'Opinion scale' },
    { value: 'multiple_choice', label: 'Multiple choice' },
    { value: 'group', label: 'Group' },
    { value: 'statement', label: 'statement' },
    { value: 'long_text', label: 'Long text' },
    { value: 'short_text', label: 'Short text' },
    { value: 'yes_no', label: 'Yes/No' }
]

class ArchivedQuestions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchTerm: '',
            typeFilter: '',
            languageFilter: '',
            archivedQuestions: [],
            rowsPerPage: 10,
            page: 0,
            questionModal: false,
            questionData: null,
            questionDateArchived: null,
            openSnackbar: false,
            snackbarMessage: '',
        }
    }

    componentDidMount() {
        if(!this.state.archivedQuestions || !this.state.archivedQuestions.length){
            this.getArchivedQuestions();
        }
    }

    // pulls archived question data from database and listens for updates
    getArchivedQuestions = () => {
        db.collection("archived").doc("archived_questions").onSnapshot(doc => {
            if(!doc.data() || !doc.data().questions) return;
            const sortedQuestions = doc.data().questions.sort((a, b) => {
                let aDate = a.dateArchived.toDate();
                let bDate = b.dateArchived.toDate();
                if(aDate > bDate) return -1;
                if(bDate > aDate) return 1;
                return 0;
            })
            this.setState({
                archivedQuestions: sortedQuestions
            });
        })
    }

    updateState = (value, state) => {
        this.setState({
            [state]: value
        }, () => {
            // if search or filter changes, set page to 0
            // if question modal is closed, set question data to null
            if (state === 'searchTerm' || state === 'languageFilter' || state === 'typeFilter') {
                this.updateState(0, "page");
            } else if (state === 'questionModal') {
                this.updateState(null, "questionData");
            }
        })
    }

    // once archived question is clicked on the table, set its data to state and open question modal
    onRowClick = (data) => {
        this.setState({
            questionModal: true,
            questionData: data.questionData,
            questionDateArchived: data.dateArchived
        });
    }

    // removes archived question from archived array and adds the question to the question_store collection
    restoreQuestion = () => {
        const { questionData, questionDateArchived } = this.state;
        const questionExists = this.context.find(q => (
            (q.ref === questionData.ref) && (q.language === questionData.language)
        ));
        if (questionExists) {
            this.setState({
                openSnackbar: true,
                snackbarMessage: "Can't restore question. Question with this ref and language already exists"
            });
        } else {
            var newQuestionRef = db.collection('question_store').doc();
            let newQuestion = {
                ...questionData,
                id: newQuestionRef.id,
                dateAdded: new Date()
            }
            newQuestionRef.set(newQuestion).then(() => {
                let archivedRef = db.collection("archived").doc('archived_questions');
                let toRemove = {
                    questionData: questionData,
                    dateArchived: questionDateArchived
                };
                archivedRef.update({
                    questions: firebase.firestore.FieldValue.arrayRemove(toRemove)
                }).then(() => {
                    this.setState({
                        openSnackbar: true,
                        snackbarMessage: `Question ${questionData.ref} was successfully restored.`,
                        questionModal: false,
                        questionData: null,
                        questionDateArchived: null
                    });
                })
            }).catch(err => {
                console.log("Error restoring doc: ", err);
            });
        }
    }

    // toggles notifcation bar
    toggleSnackbar = () => {
        this.setState({
            openSnackbar: !this.state.openSnackbar
        })
    }


    render() {
        const { archivedQuestions, searchTerm, typeFilter,
            languageFilter, rowsPerPage, page, questionData,
            questionModal, openSnackbar, snackbarMessage } = this.state;
        let filteredQuestions = archivedQuestions.filter(filterArchivedQuestions(searchTerm));
        if (typeFilter) {
            filteredQuestions = filteredQuestions.filter(question => question['questionData'].type === typeFilter);
        }
        if (languageFilter) {
            filteredQuestions = filteredQuestions.filter(question => question['questionData'].language === languageFilter);
        }
        return (
            <div style={{ textAlign: 'center', width: '100%', padding: 10 }}>
                <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
                    <h2> Archived Questions </h2>
                    <Button variant="outlined" color="primary" style={{ position: 'absolute', right: 10 }} 
                        onClick={() => this.props.history.push('/questions')}>View Survey Questions
                        </Button>
                </div>
                <div style={{ display: 'flex' }}>
                    <TextField
                        id="search-input" variant="outlined"
                        value={searchTerm}
                        onChange={(e) => this.updateState(e.target.value, "searchTerm")}
                        InputProps={{ startAdornment: (<InputAdornment position="start"> <SearchIcon /> </InputAdornment>) }}
                        style={styles['search']}
                        autoComplete="off"
                    />
                    <select style={styles['select']} value={typeFilter} onChange={(e) => this.updateState(e.target.value, 'typeFilter')}>
                        <option value="">Type</option>
                        {types.map(type => (
                            <option key={type.value} value={type.value}> {type.label} </option>
                        ))}
                    </select>
                    <select style={styles['select']} value={languageFilter} onChange={(e) => this.updateState(e.target.value, 'languageFilter')}>
                        <option value="">Language</option>
                        {languages.map(language => (
                            <option key={language.value} value={language.value}> {language.label} </option>
                        ))}
                    </select>
                </div>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <div style={{ width: '95%' }}>
                        <TableComponent
                            data={filteredQuestions}
                            headers={["Ref", "Text", "Type", "Language", "Date Archived"]}
                            fields={["questionData.ref", "questionData.title", "questionData.type", "questionData.language", "dateArchived"]}
                            updateState={this.updateState}
                            onRowClick={this.onRowClick}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            count={filteredQuestions.length}
                        />
                    </div>
                    <Dialog
                        open={questionModal}
                        onClose={() => this.updateState(!questionModal, "questionModal")}
                        fullWidth={true}
                        maxWidth={"md"}
                        aria-labelledby="question-dialog-title"
                    >
                        <DialogTitle id="question-dialog-title">
                            Archived Question View
                            <Button variant="outlined" color="secondary" onClick={this.restoreQuestion} style={{ position: 'absolute', right: 10 }}>Restore Question</Button>
                        </DialogTitle>
                        <DialogContent>
                            <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', width: '100%' }}>
                                {questionData &&
                                    <div style={{ width: '99%' }}>
                                        <select style={{ ...styles['select'], height: 40 }} value={questionData.language} onChange={(e) => this.handleQuestionChange(e.target.value, 'language')} disabled>
                                            {languages.map(language => (
                                                <option key={language.value} value={language.value}> {language.label} </option>
                                            ))}
                                        </select>
                                        <CreateQuestion
                                            field={questionData}
                                            questionView={true}
                                            disabled={true}
                                        />
                                    </div>
                                }
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button variant="outlined" onClick={() => this.updateState(!this.state.questionModal, "questionModal")}>Close</Button>
                        </DialogActions>
                    </Dialog>
                    <Snackbar
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        open={openSnackbar}
                        autoHideDuration={5000}
                        onClose={this.toggleSnackbar}
                        message={snackbarMessage}
                        action={
                            <IconButton size="small" aria-label="close" color="inherit" onClick={this.toggleSnackbar}>
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        }
                        style={{ fontSize: 14 }}
                    />
                </div>
            </div>
        )
    }
}

ArchivedQuestions.contextType = QuestionContext;

export default ArchivedQuestions;
